import script from "./question-detail-5_20_21.vue?vue&type=script&lang=tsx&setup=true"
export * from "./question-detail-5_20_21.vue?vue&type=script&lang=tsx&setup=true"

import "./question-detail-5_20_21.vue?vue&type=style&index=0&id=1df0f113&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1df0f113"]])

export default __exports__